import store from '@/store';
import {i18n} from '@/utils/i18nUtils';
import {inform} from '@/utils/dialog';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import {StickerPosition} from '@/enum/StickerPositionEnum';
import {
    RECORD_STICKER_MUTE,
    RECORD_STICKER_POSITION,
    RECORD_STICKER_VIDEO_MUTE,
} from '@/store/recordingState/recordStateAction';

/**
 * Toggle the sticker microphone, with its toast and tracking.
 */
export const toggleStickerMicMute = () => {
    if (store.getters.isStickerMute) {
        setActionEvent(ActionEvent.record_button_unmute_mic);
        inform(i18n.t('stickers.button.micro.toast.on').toString(), 'top', 'light');
    } else {
        setActionEvent(ActionEvent.record_button_mute_mic);
        inform(i18n.t('stickers.button.micro.toast.off').toString(), 'top', 'danger');
    }
    store.dispatch(RECORD_STICKER_MUTE);
};

/**
 * Toggle the sticker webcam, with its toast and tracking.
 * Turning the webcam back on also restores the sticker on screen.
 */
export const toggleStickerVideoMute = () => {
    if (store.getters.isStickerVideoMute) {
        store.dispatch(RECORD_STICKER_POSITION, StickerPosition.BOTTOM_LEFT);
        setActionEvent(ActionEvent.record_button_unmute_video);
        inform(i18n.t('stickers.button.webcam.toast.on').toString(), 'top', 'light');
    } else {
        setActionEvent(ActionEvent.record_button_mute_video);
        inform(i18n.t('stickers.button.webcam.toast.off').toString(), 'top', 'light');
    }
    store.dispatch(RECORD_STICKER_VIDEO_MUTE);
};

/**
 * Show or hide the sticker on the recorded screen.
 */
export const toggleStickerVisibility = () => {
    if (store.getters.getStickerPosition === StickerPosition.NONE) {
        store.dispatch(RECORD_STICKER_POSITION, StickerPosition.BOTTOM_LEFT);
    } else {
        store.dispatch(RECORD_STICKER_POSITION, StickerPosition.NONE);
    }
};
